import { useEffect, useState } from "react";
import { useApp } from "../../store.jsx";
import { Icon } from "../Common.jsx";
import { getCandidateTasks, linkProjectTasks } from "../../lib/api";

export default function LinkTasksModal({ projectId, onSaved }) {
  const { closeModal, toast } = useApp();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(() => new Set());
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getCandidateTasks({ projectId })
      .then((d) => setTasks(d.tasks || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projectId]);

  const toggle = (id) =>
    setSelected((s) => {
      const n = new Set(s);
      if (n.has(id)) n.delete(id);
      else n.add(id);
      return n;
    });

  const filtered = tasks.filter((t) =>
    t.title.toLowerCase().includes(search.trim().toLowerCase()),
  );

  const submit = async () => {
    if (selected.size === 0) {
      closeModal();
      return;
    }
    setSaving(true);
    try {
      await linkProjectTasks(projectId, [...selected]);
      toast(`Linked ${selected.size} task${selected.size === 1 ? "" : "s"}`, "success");
      closeModal();
      onSaved?.();
    } catch (e) {
      toast(e.message === "task_not_found" ? "A selected task no longer exists." : e.message || "Could not link tasks", "error");
      setSaving(false);
    }
  };

  return (
    <>
      <div className="modal-head">
        <h3>Link tasks</h3>
        <button className="icon-btn" onClick={closeModal}>
          <Icon name="x" size={16} />
        </button>
      </div>
      <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div className="toolbar-search">
          <Icon name="search" size={14} />
          <input
            type="text"
            placeholder="Search active tasks…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div
          style={{
            maxHeight: 320,
            overflowY: "auto",
            border: "1px solid var(--border)",
            borderRadius: 8,
          }}
        >
          {loading ? (
            <div style={{ padding: 16, color: "var(--text-muted)", fontSize: 13 }}>Loading…</div>
          ) : filtered.length === 0 ? (
            <div style={{ padding: 16, color: "var(--text-muted)", fontSize: 13 }}>
              No active tasks available to link.
            </div>
          ) : (
            filtered.map((t) => (
              <label
                key={t.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderBottom: "1px solid var(--border)",
                }}
              >
                <input type="checkbox" checked={selected.has(t.id)} onChange={() => toggle(t.id)} />
                <span style={{ flex: 1 }}>{t.title}</span>
                <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{t.user?.name || "—"}</span>
              </label>
            ))
          )}
        </div>
      </div>
      <div className="modal-foot">
        <button className="btn btn-ghost" onClick={closeModal} disabled={saving}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={submit} disabled={saving || selected.size === 0}>
          {saving ? "Linking…" : `Link ${selected.size || ""} task${selected.size === 1 ? "" : "s"}`}
        </button>
      </div>
    </>
  );
}
